/**
 * 화면이 우리 `/api/influencer/profiles` 에 묻는 것 — 계정의 얼굴·팔로워.
 *
 * ⚠️ 관문 뒤라 로그인 토큰이 필수다(헤더를 빼면 401).
 * ⚠️ 응답 모양은 서버 BFF 가 이미 계약으로 빚어 보낸다 — 여기서는 목록 모양만 지킨다.
 */

import type { ProfileLookupItem, ProfileLookupResult } from 'src/types/influencer/profile-lookup';

import { bearerAuthHeader } from 'src/lib/firebase/auth-kit';

import { resolveMockProfileLookups } from './search-all-mock';

/**
 * @returns 계정별 결과 — ⚠️ **순서가 요청과 다를 수 있다**(채널+계정으로 맞춘다).
 *   서버가 설정 전·실패면 빈 목록(화면은 머리글자로 남는다)
 */
export async function fetchProfileLookups(
  items: ProfileLookupItem[],
  signal?: AbortSignal,
): Promise<ProfileLookupResult[]> {
  if (items.length === 0) return [];
  const mocked = resolveMockProfileLookups(items);
  if (mocked) return mocked;

  const res = await fetch(PROFILES_PATH, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(await bearerAuthHeader()) },
    body: JSON.stringify({ items }),
    signal,
  });
  if (!res.ok) return [];
  const data = await res.json().catch(() => ({}));
  return Array.isArray(data?.results) ? (data.results as ProfileLookupResult[]) : [];
}

/** 못 쓴 얼굴 신고 — 결과를 기다리지 않아도 된다 */
export async function reportProfileLookupFailure(channel: string, account: string): Promise<void> {
  await fetch(`${PROFILES_PATH}/report`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(await bearerAuthHeader()) },
    body: JSON.stringify({ channel, account }),
  }).catch(() => undefined);
}

/** ⚠️ 주소는 여기 한 곳뿐이다 */
const PROFILES_PATH = '/api/influencer/profiles';
